import { VERSION_PLACEHOLDER } from '@nx-customer-apps/components';
import { Environment } from './environment.model';

export const environment: Environment = {
    production: true,
    environment: 'preview',
    accountAppUrl: 'https://account-integration.viessmann-climatesolutions.com',
    baseApiUrl: 'https://api-integration.viessmann-climatesolutions.com',
    baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
    partnerPortalBaseUrl: 'https://partnerportal-staging.viessmann-climatesolutions.com',
    translationsBaseUrl: 'https://api-integration.viessmann-climatesolutions.com/translations/v2',
    apiKey: '80803526-d9fa-4aec-af44-d65381beee97',
    phraseappProjectId: {
        homePlanner: '8e2aa2a65cc63ba26a928b36582552c8',
        globalHeader: '30b1afd8a62ba6728e53abffe9101eb2',
        designSystemWeb: 'ec38b083a23c58c604a49d7f443dd7f2',
        flows: '5cfb7f9a03a8d6fba82d29aa840b7715',
        components: '31fb8c95c8f4afd6c68b63a48b96116b'
    },
    authConfig: {
        issuer: 'https://iaml3.viessmann-climatesolutions.com',
        loginUrl: 'https://iaml3.viessmann-climatesolutions.com/idp/v3/authorize',
        logoutUrl: 'https://iaml3.viessmann-climatesolutions.com/idp/v3/sso/logout',
        tokenEndpoint: 'https://iaml3.viessmann-climatesolutions.com/idp/v3/token',
        userinfoEndpoint: 'https://iaml3.viessmann-climatesolutions.com/idp/v2/tokeninfo',
        redirectUri: 'https://home-planner-preview.viessmann-climatesolutions.com/utils',
        clientId: '229dbb13222cb6cb69c61b052f6747a7',
        postLogoutRedirectUri: '',
        responseType: 'code',
        scope: 'Internal',
        oidc: false,
        clockSkewInSec: 0
    },
    vapi: {
        baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
        entrypoint: `/planning-projects/${VERSION_PLACEHOLDER}-preview`,
        version: 'v1'
    }
};
